import formCreate from '@form-create/element-ui';
import Form from './form.vue';

export {
  formCreate,
};
export default Form;
